import styled from '@emotion/styled';

const CompareQuotesStyle = styled('div')`
    line-height: 1.2;
    .box-header {
        background: #1e3254;
        font-size: 20px;
        font-weight: 500;
        padding: 16px 0;
        .icon-close {
            font-size: 28px;
            cursor: pointer;
        }
    }

    .ant-spin-dot-item {
        background: #fff;
    }

    .content-compare {
        margin-top: 20px;
        .item-compare {
            max-width: 329px;
            width: 100%;
            font-size: 14px;
            .num {
                font-weight: 700;
                color: #93fce7;
                font-size: 18px;
                margin-bottom: 16px;
            }
            .title {
                font-weight: 700;
                padding: 10px 16px;

                color: #fff;
                background: #1e3254;
                span {
                    height: 2.8rem;
                    line-height: 1.5;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
            .item-content {
                color: #000;
            }
            .main-image {
                border-radius: 6px 6px 0 0;
                overflow: hidden;
                position: relative;
                vertical-align: middle;
                &::before {
                    display: block;
                    content: '';
                    width: 100%;
                    padding-top: 58%;
                }
                img {
                    right: 0;
                    width: 100%;
                    height: 100%;
                    bottom: 0;
                    left: 0;
                    top: 0;
                    position: absolute;
                    object-fit: cover;
                    border-radius: 6px 6px 0 0;
                }
            }
            .reference {
                background: #f2fffa;
                text-align: center;
                padding: 10px 0;
                font-weight: 600;
            }
            .box-detail {
                padding: 16px;
                overflow-y: auto;
                height: calc(100vh - 430px);
                background: #fff;
                border-radius: 0 0 6px 6px;
                .item {
                    display: flex;
                    align-items: baseline;
                    gap: 10px;
                    padding: 5px 0;

                    .icon-detail {
                        width: 20px;
                        position: relative;
                        top: 2px;
                        color: rgb(18, 184, 151);
                    }

                    .title-detail {
                        width: 90%;
                    }
                }
                .total-price {
                    font-size: 16px;
                    font-weight: 700;
                }

                .price {
                    font-weight: 700;
                    margin: 12px 0 3px;
                }
            }
        }
    }

    .box-carousel {
        position: relative;

        .icon-circle {
            cursor: pointer;
            position: absolute;
            top: 218px;
            font-size: 30px;
            border-radius: 50%;
            color: rgb(18, 184, 151);
            background: #fff;
            border: 1px solid #fff;
            z-index: 1;
            &.btn-prev {
                left: -5px;
            }
            &.btn-next {
                right: -5px;
            }
        }
    }

    .ant-skeleton {
        width: 100%;
    }

    @media screen and (max-width: 767px) {
        .box-header {
            font-size: 16px;
            padding: 16px 0;
            .icon-close {
                font-size: 18px;
            }
        }
        .content-compare {
            .item-compare {
                margin: auto;
            }
        }
    }

    @media screen and (max-height: 600px) {
        .content-compare {
            .item-compare {
                max-height: calc(100vh - 85px);
                overflow-y: auto;

                .box-detail {
                    overflow-y:unset;
                    height: auto;
                }
            }
        }
    }
`;

export default CompareQuotesStyle;
